<template>
  <div id="app" class="relative">
    <!-- 임시 팝업 -->
    <div v-if="tempPopup" class="temp_popup">
      <div class="temp_popup_inner">
        <img src="@/assets/images/temp_pop.png" alt="임시 팝업" />
        <div class="temp_popup_btn_wrap">
          <button class="forever_nonview" @click="hideForever"></button>
          <button class="check_confirm" @click="hideOne"></button>
        </div>
      </div>
    </div>
    <!-- ###### 임시 팝업 -->
    <Notice />
    <div v-if="isLoading" class="spinnerWrapper">
      <!-- <Spinner class="spinner" /> -->
      <Spinner
        :active="isLoading"
        loader="dots"
        color="#007FA2"
        background-color="#000"
        :opacity="0.5"
        :is-full-page="true"
      />
    </div>
    <!-- <LanguageSwitcher /> -->
    <Header
      v-if="
        !(
          $route.path.includes('/qrcode') || $route.path.includes('/payment')
        ) &&
        (isPc ||
          !($route.path.includes('/login') || $route.path.includes('/join')))
      "
      :is-search="this.isSearch"
    />
    <router-view />
    <Footer
      v-if="
        !(
          $route.path.includes('/qrcode') || $route.path.includes('/payment')
        ) &&
        (isPc ||
          !($route.path.includes('/login') || $route.path.includes('/join')))
      "
    />
  </div>
</template>

<script>
import Header from '@/components/common/Header.vue'
import Footer from '@/components/common/Footer.vue'
import Notice from '@/components/popup/Notice.vue'
// import LanguageSwitcher from '@/components/common/LanguageSwitcher.vue'
// import Spinner from 'vue-loading-spinner/src/components/CubeShadow.vue'

import { showPopup, universityName, isNiaMode } from '@/store/constants'
import {
  AUTH_REFRESH
  // STORE_POPUP
} from '@/store/types'
import { mapGetters } from 'vuex'

import 'vue-loading-overlay/dist/vue-loading.css'
import '@/assets/css/base.css'
import '@/assets/global.scss'

export default {
  components: {
    Header,
    Footer,
    Notice
    // LanguageSwitcher,
    // Spinner
  },
  // **********************event
  data() {
    return {
      universityName,
      showPopup,
      isShowEventPopup: true,
      isShowEventPopup2: true,
      isNiaMode,
      isSearch: true,
      checked: false,
      isPc: false,
      isMobile: false,
      tempPopup: false
    }
  },
  // beforeCreate() {
  //   document.title = `${universityName} 이앨리스 - 온라인서점`
  // },
  // **********************event

  computed: {
    isLoading() {
      if (this.isAuthLoading || this.getLoading) return true
      return false
    },
    layout() {
      return `${this.$route.meta.layout || 'default'}-layout`
    },
    cookieNm() {
      if (this.universityName) {
        return this.universityName.trim()
      } else {
        return ''
      }
    },
    popupImage() {
      // console.log(this.getPopup?.popup?.url[0])
      return this.getPopup?.popup?.url[0].bannerUrl
    },
    popupUrl() {
      // console.log(this.getPopup?.popup?.url[0])
      return this.getPopup?.popup?.url[0].linkUrl
    },
    popupTitle() {
      // console.log(this.getPopup?.popup?.url[0])
      return this.getPopup?.popup?.url[0].bannerTitle
    },
    ...mapGetters(['getLoading', 'isAuthLoading', 'getPopup'])
  },
  beforeMount() {
    // const cookieNm = this.universityName.trim()
    // **********************event
    let value = document.cookie.match(
      `(^|;) ?evtPopupYn${this.cookieNm}1=([^;]*)(;|$)`
    )
    value ? (this.isShowEventPopup = false) : ''

    let value2 = document.cookie.match(
      `(^|;) ?evtPopupYn${this.cookieNm}2=([^;]*)(;|$)`
    )
    value2 ? (this.isShowEventPopup2 = false) : ''
    // **********************event
    document.documentElement.style.setProperty(
      '--scrollbar-width',
      window.innerWidth - document.documentElement.clientWidth + 'px'
    )
  },
  updated() {
    this.$route.name != 'search'
      ? (this.isSearch = false)
      : (this.isSearch = true)
    // if (this.$route.name != 'search') {
    //   this.isSearch = false
    //   console.log('notchange')
    // }
  },
  async mounted() {
    this.checkPopupStatus()
    this.checkWindowSize()
    window.addEventListener('resize', this.checkWindowSize)
    let token = localStorage.getItem('token')

    if (token) {
      try {
        // console.log('a-issue')
        await this.$store.dispatch(AUTH_REFRESH)
      } catch (err) {
        // console.log(err)
        // this.$store.dispatch(AUTH_LOGOUT)
      }
    }
    // await this.$store.dispatch(STORE_POPUP)
    this.$cookies.get('pcMode') === 'isPcModeTrue'
      ? document
          .getElementById('viewport')
          .setAttribute('content', process.env.VUE_APP_VIEWPORT_PCMODE)
      : ''
  },
  methods: {
    checkWindowSize() {
      this.isPc = window.innerWidth > 480
      this.isMobile = window.innerWidth <= 480
    },
    checkCloseEvtPopup() {
      const chKBox = document.getElementById('closeOneDay')
      if (chKBox.checked == true) {
        var todayDate = new Date()
        todayDate.setHours(24)
        document.cookie =
          `evtPopupYn${this.cookieNm}1` +
          '=' +
          escape('N') +
          '; path=/; expires=' +
          todayDate.toGMTString() +
          ';'
        this.isShowEventPopup = false
      } else {
        this.isShowEventPopup = false
      }
    },
    onCancel() {
      // console.log('User cancelled the loader.')
    },
    closeEvtPopup(no) {
      no === 1
        ? (this.isShowEventPopup = false)
        : (this.isShowEventPopup2 = false)
    },
    closeOneDay(no) {
      var todayDate = new Date()
      todayDate.setHours(24)
      document.cookie =
        `evtPopupYn${this.cookieNm}${no}` +
        '=' +
        escape('N') +
        '; path=/; expires=' +
        todayDate.toGMTString() +
        ';'
      no === 1
        ? (this.isShowEventPopup = false)
        : (this.isShowEventPopup2 = false)
    },
    goEvtPage() {
      // window.ChannelIO('track', '반품')
      // window.open(
      //   'https://docs.google.com/forms/d/e/1FAIpQLSd6ak5REDhqsDP5N-OnUq97PuOkH0eDQfSu9qjncstwFwu8Mg/viewform',
      //   'popupEvt',
      //   'height=' + screen.height + ',width=' + screen.width + 'fullscreen=yes'
      // )
    },
    /**
     * 핵 중요!!!!
     * 다음에 적용할때 foreverHidePopup 쿠키 삭제하고 다른이름으로 명명해서 쿠키 적용시킬것.
     * 왜냐하면 현재 쿠키 적용시키면 페이지 재방문 시 팝업 안보이는 버그 발생함.
     */
    checkPopupStatus() {
      // 영구적으로 보지 않기 확인
      const foreverHide = localStorage.getItem('foreverHidePopup')

      // 임시 숨김 확인
      const tempHide = sessionStorage.getItem('tempHidePopup')

      // 현재 시간 가져오기
      const now = new Date()

      // 2025년 5월 12일 17:50 설정 (종료 시간)
      const endDate = new Date(2025, 4, 12, 17, 50, 0) // 월은 0부터 시작

      // 현재 시간이 종료 시간 이후인지 확인
      if (now >= endDate) {
        // 종료 시간 이후라면 팝업 영구 숨김 처리
        localStorage.setItem('popupEndDatePassed', 'true')
        this.tempPopup = false
        return
      }

      // 이미 종료 시간을 지났는지 확인 (페이지 재방문 시)
      const endDatePassed = localStorage.getItem('popupEndDatePassed')
      if (endDatePassed === 'true') {
        this.tempPopup = false
        return
      }

      // 영구 숨김이나 임시 숨김 설정이 되어있지 않을 때만 팝업 표시
      if (foreverHide !== 'true' && !tempHide) {
        this.tempPopup = true
      } else {
        this.tempPopup = false
      }

      // 디버깅용 로그 (나중에 제거)
      // console.log('팝업 상태 확인:', {
      //   현재시간: now.toLocaleString(),
      //   종료시간: endDate.toLocaleString(),
      //   종료시간지남: now >= endDate,
      //   이미종료됨: endDatePassed === 'true',
      //   영구숨김: foreverHide === 'true',
      //   임시숨김: tempHide === 'true',
      //   팝업표시: this.tempPopup
      // })
    },
    hideForever() {
      localStorage.setItem('foreverHidePopup', 'true')
      this.tempPopup = false
    },
    hideOne() {
      this.tempPopup = false
    },
    getCookie(name) {
      const value = `; ${document.cookie}`
      const parts = value.split(`; ${name}=`)
      if (parts.length === 2) return parts.pop().split(';').shift()
      return null
    }
  }
}
</script>

<style lang="scss">
@import '../src/assets/scss/_variables';
#app {
  background: #f0f5fa;
  transition: $ease;
  // FIXES ISSUES WITH BOTTOM SPACING ON AUTH AND OTHER PAGES
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
@media all and (min-width: 1440px) {
  .location .btn_open_snb.active {
    width: 22px;
    margin-right: 29px;
  }

  .aside_snb + .library_st .section {
    max-width: 100%;
  }
  .aside_snb + .library_st .location_wrap {
    max-width: 100%;
    padding-left: 66px;
    padding-right: 66px;
  }
}

.spinnerWrapper {
  z-index: 5555;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  touch-action: none;
  overflow-y: auto;
  background-color: rgba(42, 40, 43, 0.6);
}

.spinner {
  position: absolute;
  top: 50%;
  z-index: 9999;
  margin: auto;
  left: calc(50% - 25px);
  background-color: #007aff !important;
}

.temp_popup {
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  width: 100%;
  height: 100%;
}

.temp_popup_inner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.temp_popup_btn_wrap {
  position: absolute;
  bottom: 68px;
  left: 60px;
  display: flex;
  gap: 8px;
  width: 70%;
  height: 50px;
}

.temp_popup_btn_wrap button {
  width: 100%;
  height: 100%;
}
</style>
